import React from 'react'

export const SidebarRoot = ({ children }) => {
  return <aside className="menu">{children}</aside>
}
